import { type AnyObject } from '@Types';
import { type BotUiContext } from 'TutorBotConversation';
import transformKeyCase from 'Utils/transformKeyCase';

export function getLogInfo({
    uiContext,
    agentIdentifier,
    extraTokenAttributes = {},
}: {
    uiContext: BotUiContext;
    agentIdentifier: string;
    extraTokenAttributes?: AnyObject;
}) {
    return transformKeyCase<AnyObject>(
        { params: extraTokenAttributes, agentIdentifier, label: uiContext, ui_context: uiContext },
        { to: 'snakeCase' },
    );
}
